import request from '@/plugins/axios';

//GET
// /_product_/user/authorization
// 用户自动授权归属平台
export function authorization(params) {
    return request[0]({
        url: '/_product_/user/authorization',
        method: 'get',
        params
    })
}

//POST
// /sso/forgetPassword
// 产品用户忘记密码修改
export function forgetPassword(params,data) {
    return request[0]({
        url: '/sso/forgetPassword',
        method: 'post',
        params,
        data
    })
}

//GET
// /_product_/user/getUserInfo
// 获取用户信息
export function getUserInfo() {
    return request[0]({
        url: '/_product_/user/getUserInfo',
        method: 'get',
    })
}


